<template>
  <history-plate v-if="plate" :record="object" :objectId="objectId" />
  <history v-else :objectId="objectId" />
</template>

<script>
import History from '@/components/History.vue'
import HistoryPlate from '@/components/HistoryPlate.vue'

export default {
  components: { History, HistoryPlate },
  props: {
    // The object page's new look (Seaded -> Objekt uues kujunduses): the
    // client page's Ajalugu, only the changes and the old value beside the
    // new. overview is View.vue's, for the count.
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: () => ({})
    },
    objectId: {
      required: true
    }
  }
}
</script>
